import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaUserPlus } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from  '../../../components/Pagination/Pagination';
import Moment from 'react-moment';
import { API } from 'aws-amplify';

const UserList = (props) => {
	const [userList, setUserList] = useState([]);
	const [users, setUsers] = useState([]);
	const [user, setUser] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(10);

	// Load users
	useEffect(()=>{
        const fetchUsers = async () => {
            setIsLoading(true);
			const params = {
				headers: {
					'x-api-key': process.env.REACT_APP_API_KEY,
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
			}

			//Get user asset list
			// let user_assets = []			
			// user_assets = await API.get('user_assets','/', params)
            let user_assets = props.user.user_assets || []


            API.get('users','/', params)
            .then(res => {
                let userList = [];
                res.Users.forEach((item) => {
                    let user ={}
                    user.username = item.Username;
                    item.Attributes.forEach((e) => {
                        if (e.Name === 'name') user.name = e.Value;
                        if (e.Name === 'custom:administrator') user.admin = e.Value;
                        if (e.Name === 'custom:contractor') user.contractor = e.Value;
                    })
                    user.status = item.UserStatus;
                    user.date_created = <Moment local format='DD-MM-YYYY' date={ item.UserCreateDate } />;
                    user.last_upd = <Moment local format='DD-MM-YYYY' date={ item.UserLastModifiedDate } />;
                    user.enabled = item.Enabled;

                    userList.push(user);
                })

				if (props.user.profile === 'SubAdmin') 
					userList = userList.filter(i => i.contractor === props.user.contractor)

				
				userList = userList.map(item => ({...item, 
					profile: (user_assets.find(i => i.id === item.username) 
							&& user_assets.find(i => i.id === item.username).settings.profile ) || '' }));

				// console.log(userList)
				userList.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setUserList(userList);
                setUsers(userList);
            });

 			setIsLoading(false);
		}
		if (props.user.profile)
			fetchUsers();
	}, [props.user]);


	// Pagination
	  const indexOfLastItem = currentPage * itemsPerPage;
	  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  const currentItemList = userList.slice(indexOfFirstItem, indexOfLastItem);

	  // Change page
	  const paginate = pageNumber => setCurrentPage(pageNumber);

	  useEffect(() => {
        const handleSearch = () => {
            let results = users;
            // User
            if (user){
				results = results.filter(results =>
					(results.name && results.name.toLowerCase().includes(user.toLowerCase())) ||
					(results.username && results.username.toLowerCase().includes(user.toLowerCase())) ||
					(results.contractor && results.contractor.toLowerCase().includes(user.toLowerCase()))
				)
            }
            setUserList(results);
            paginate(1);
        }
		handleSearch();
    }, [user, users]);

	return (
	<div className="DeviceList">
	<div className="col-md-12">
		<div className="row header pb-0">
			<div>Users</div>
			<div className='col-md-3'>
				<Form.Group controlId="user">
				<Form.Control
					as="input"
					value={user}
					onChange={e => {setUser(e.target.value)}}
					placeholder='Search by name, email or group '
					type="text" />
				</Form.Group>
			</div>
			<div className="col-md-8 text-right">
				{(props.viewPermissions.find(i => i === 'add_users'))?
				<Button variant="success" onClick={()=>{props.history.push('/signup/')}}>
					Add User &nbsp;
					<FaUserPlus />
				</Button>
				:''}
			</div>
		</div>

		<div className="row">
			<div className="col-md-12 div-content">

				{(!isLoading) ? (
					(currentItemList.length === 0) ? (
						// <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
						''
					):(
					<div>
					<Table responsive hover variant="light">
					<thead>
						<tr>
						<th className='border-bottom'>User</th>
						<th className='border-bottom'>Email</th>
						<th className='border-bottom'>Profile</th>
						{/* <th className='border-bottom'>Created</th> */}
						<th className='border-bottom'>Group</th>
						<th className='border-bottom'>Updated</th>
						<th className='border-bottom'>Status</th>
						<th className='border-bottom'>Enabled</th>
						</tr>
					</thead>
					<tbody>
					{currentItemList.map((item, i) => (
					<tr key={i} className='table-tr'>
						<td className="link border-bottom" key="item.username" onClick={() => props.history.push('/user_det/'+ item.username )}>
							{item.name}
						</td>
						<td className='border-bottom'>{ item.username }</td>
						<td className='border-bottom'>{ item.profile }</td>
						{/* <td className='border-bottom'>{ (item.admin==='true') ? 'Yes' : 'No' }</td> */}
						{/* <td className='text-nowrap border-bottom'>{ item.date_created }</td> */}
						<td className='text-nowrap border-bottom'>{ item.contractor }</td>
						<td className='text-nowrap border-bottom'>{ item.last_upd }</td>
						<td className='border-bottom'>{ item.status }</td>
						<td className='border-bottom'>{ (item.enabled ===true) ? 'Enabled':'Disabled' }</td>
					</tr>
					))}
					</tbody>
					</Table>

					<Pagination
						sizePerPage={itemsPerPage}
						currentPage={currentPage}
						totalSize={userList.length}
						changeCurrentPage={paginate}
						theme="bootstrap"
					/>
				</div>

				)):(

					<div className="col-md-12">
					<Spinner animation="grow" size="sm" role="status" variant="warning" />
					<span className="text-dark">Loading...</span>
					</div>
				)}

			</div>
		</div>
		</div>
	</div>
	);

}

const mapStateToProps = state => {
    return {
		user: state.auth.user,
        viewPermissions: state.auth.viewPermissions,
    };
  };

export default connect(mapStateToProps)(UserList);

